export const Category = new Map<number, {label: string}>([
  [1, {label: 'Antincendio'}],
  [2, {label: 'Primo Soccorso'}],
  [3, {label: 'Sicurezza Sul Lavoro'}],
  [4, {label: 'Haccp'}],
  [5, {label: 'Attrezzature'}],
  [6, {label: 'Rischi Specifici'}],
])
